<template>
    <div>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("gastosPorCasa")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change="getGastosCasa()">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="$t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="$t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <label>&nbsp;</label>
                            <div class="form-group">
                                <button class="btn btn-primary" @click="getGastosCasa()"><i
                                        class="fa fa-refresh" v-if="loading"></i>
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <template v-else-if="respuesta">

                <div class="col-md-8">
                    <div class="card">
                        <template v-if="list.length>0">
                            <div class="row justify-content-between div-export">

                                <div class="col-md-12 col-xs-12 text-left">
                                    <el-dropdown>
                                        <el-button type="primary" size="small">
                                            <i class="fa fa-file"></i>
                                            {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <a :href="urlExportPDF">
                                                <el-dropdown-item class="text-danger">
                                                    <strong><i class="fa fa-file-pdf"></i>
                                                        {{$t("exportarPdf")}}</strong>
                                                </el-dropdown-item>
                                            </a>
                                            <a :href="urlExportExcel">
                                                <el-dropdown-item class="text-success">
                                                    <strong><i class="fa fa-file-excel"></i>
                                                        {{$t("exportarExcel")}}</strong>
                                                </el-dropdown-item>
                                            </a>
                                        </el-dropdown-menu>
                                    </el-dropdown>

                                </div>
                            </div>

                            <div class="table-responsive">
                                <table class="table table-bordered table-striped">
                                    <thead class="thead-dark">
                                    <tr>
                                        <th>{{$t("casa")}}</th>
                                        <th>{{$t("importe")}}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="obj in list">
                                        <td>{{obj.nameCasa}}</td>
                                        <td align="right">{{obj.total | currency}}</td>
                                    </tr>
                                    </tbody>
                                    <tfoot>
                                    <tr class="table-success">
                                        <td><strong>{{$t("total")}}</strong></td>
                                        <td class="text-right"><strong>{{getTotalPrecio | currency}}</strong></td>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </template>
                        <template v-else>
                            <p><i class="fa fa-info-circle"></i>
                                <small>
                                    {{$t("infoConsumo")}}
                                </small>
                            </p>
                            <div class="alert alert-danger" role="alert">
                                {{$t("noHayGastosPorCasasEnEsteRangoDeFechas")}}
                            </div>
                        </template>
                    </div>
                </div>

                <div class="col-md-4 " v-show="this.list.length > 0">
                    <div class="card">
                        <canvas id="chart"></canvas>


                    </div>
                </div>
            </template>
        </div>
    </div>


</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    //import Chart from '../../../../../node_modules/chart.js/src/chart';
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    import { mapState } from 'vuex'

    export default {
        created() {
            this.$store.dispatch("setNameRoute", this.$i18n.t("gastos"));

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;

            }


            this.getBusiness();


        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        data() {
            return {
                loading: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                dates: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                list: [],
                mode: 0,
                procedencia: 2,
                $Chart: null,
                objectChart: null,
                contador: 0,


                //DATOS
                listBusinesses: [],
                idBusiness: 0,

                respuesta: true,


            }
        },
        computed: {
    
            ...mapState(["permiso"]),
            
            urlExportPDF() {
                return this.$store.getters.apiUrl+"/gastos/exportGastosByCasa/PDF?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt


            },
            urlExportExcel() {
                return this.$store.getters.apiUrl+"/gastos/exportGastosByCasa/Excel?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt


            },

            getTotalPrecio() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.total;

                });
                return total;
            }
        },
        methods: {

            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        vm.listBusinesses = response.data.result;

                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        }
                        else {

                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.getGastosCasa();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            getGastosCasa() {


                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    } else {
                        this.loading = true;
                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.axios.get(this.$store.getters.apiUrl + "gastos/getExpensesByCasa", config)
                            .then(function (response) {
                                if (response.data.response) {

                                    vm.list = response.data.result;

                                    vm.respuesta = true;
                                    vm.initChart();

                                }
                                else {
                                    swal({
                                        title: vm.$t('error'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });
                                    vm.respuesta = false;

                                }
                                vm.loading = false;

                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }
            },

            initChart() {
                let labels = this.list.map(function (x) {
                    return x.nameCasa;
                });


                let data = this.list.map(function (x) {
                    return x.total;
                });


                var randomColor = require('randomcolor');

                var colors = randomColor({luminosity: 'dark', count: labels.length, format: 'rgb'});

                let backgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)";
                });

                let borderColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)";
                });

                let hoverBackgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)";
                });

                if (this.contador === 0) {

                    if (this.list.length > 0) {
                        this.objectChart = new Chart("chart", {

                            type: 'pie',
                            data: {
                                labels: labels,
                                datasets: [{
                                    data: data,
                                    backgroundColor: backgroundColors,
                                    borderColor: borderColors,
                                    hoverBackgroundColor: hoverBackgroundColors,
                                    borderWidth: 1
                                }]
                            },
                            options: {
                                legend: {
                                    display: true,
                                    position: 'bottom',


                                }
                            }
                        });


                        this.contador++;
                    }
                }
                else {

                    this.objectChart.destroy();

                    this.objectChart = new Chart("chart", {

                        type: 'pie',
                        data: {
                            labels: labels,
                            datasets: [{
                                data: data,
                                backgroundColor: backgroundColors,
                                borderColor: borderColors,
                                hoverBackgroundColor: hoverBackgroundColors,
                                borderWidth: 1
                            }]
                        },
                        options: {
                            legend: {
                                display: true,
                                position: 'bottom'
                            }
                        }
                    });

                }
            }
        }
    }
</script>

<style scoped>


    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Casas/GastosCasas.vue